import { render } from "./App.vue?vue&type=template&id=306c9094"
import script from "./App.vue?vue&type=script&lang=js"
export * from "./App.vue?vue&type=script&lang=js"

import "./App.vue?vue&type=style&index=0&id=306c9094&lang=css"

import exportComponent from "C:\\JRIBIC\\Projects\\_myProjects\\_GIT\\general\\Vue.js\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__